import { SUBSCRIBE_CHANNEL } from '../constants';
import createEntityLocalizer from '../utils/createEntityLocalizer';

interface CreateLocalizedDate {
    subscribeChannelKey?: string;
    handlerKey?: string;
}

export interface LocalizedDateProps<D> {
    date: D;
}

export const createLocalizedDate = <D,>({
    subscribeChannelKey = SUBSCRIBE_CHANNEL,
    handlerKey = 'localizeDate',
}: CreateLocalizedDate = {}) =>
    createEntityLocalizer<LocalizedDateProps<D>>({
        subscribeChannelKey,
        handlerKey,
        displayName: 'LocalizedDate',
        entityName: 'date',
    });

export default createLocalizedDate();
